import * as React from 'react';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { classes, st } from './Breadcrumbs.st.css';
import { DATA_HOOKS } from './constants';
import { TextButton, TextButtonPriority } from '../TextButton';
import { BreadcrumbsDefaultProps, BreadcrumbsProps } from './types';

/** Breadcrumbs is a type of navigation scheme which reveals the user’s location in a website or Web application. */
export class Breadcrumbs extends React.Component<BreadcrumbsProps> {
  static displayName = 'Breadcrumbs';
  static defaultProps: BreadcrumbsDefaultProps = {
    showTrailOnMobileMode: false,
  };

  render() {
    const {
      className,
      items,
      showTrailOnMobileMode,
      onClick,
      'data-hook': dataHook,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
    } = this.props;
    const crumbs = items.map((item, index) => {
      const itemProps = {
        ...item,
        onClick: () => {
          onClick(item);
        },
      };
      return (
        <Breadcrumb
          key={item.id}
          {...itemProps}
          isLast={index === items.length - 1}
        />
      );
    });

    const noTrailCrumbs = (
      <Breadcrumb
        {...items[items.length - 2]}
        onClick={() => {
          onClick({ ...items[items.length - 2] });
        }}
        mobileNoTrail
      />
    );

    return (
      <TPAComponentsConsumer>
        {({ mobile, rtl }) => (
          <nav
            className={st(classes.root, { rtl }, className)}
            data-hook={dataHook}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            data-mobile={mobile ? true : undefined}
          >
            <ol className={classes.list}>
              {mobile && !showTrailOnMobileMode ? noTrailCrumbs : crumbs}
            </ol>
          </nav>
        )}
      </TPAComponentsConsumer>
    );
  }
}

const Breadcrumb = ({
  value,
  href,
  onClick,
  isLast = false,
  mobileNoTrail = false,
}) => {
  return (
    <>
      <li
        data-hook={DATA_HOOKS.BREADCRUMB}
        className={classes.crumb}
        aria-current={isLast ? 'page' : undefined}
      >
        {mobileNoTrail ? (
          <TextButton
            as="a"
            priority={TextButtonPriority.secondary}
            href={href}
            className={classes.button}
            prefixIcon={<ChevronLeft aria-hidden />}
            data-hook={DATA_HOOKS.BREADCRUMB_BUTTON}
            onClick={onClick}
          >
            {value}
          </TextButton>
        ) : isLast ? (
          <span className={st(classes.noButtonCrumb)}>{value}</span>
        ) : (
          <TextButton
            as="a"
            priority={TextButtonPriority.secondary}
            href={href}
            className={classes.button}
            data-hook={DATA_HOOKS.BREADCRUMB_BUTTON}
            onClick={onClick}
          >
            {value}
          </TextButton>
        )}
      </li>
      {isLast || mobileNoTrail || (
        <ChevronRight aria-hidden className={classes.chevron} />
      )}
    </>
  );
};
